export const Copy = 'copy'
